import React, { useState } from 'react';
import axios from 'axios';
import { Sidebar } from './Dashboard';

const API = 'https://tribaltech-backend.onrender.com';

const plans = [
  {
    id: 'starter',
    name: 'Starter',
    price: 29,
    color: 'var(--teal)',
    features: [
      'Automatic leak detection across 30+ piracy platforms',
      'Auto DMCA filing + Google deindexing',
      'Audio + visual fingerprinting (powers leak detection)',
      'Takedown tracker',
      'Email alerts',
      '3-day free trial',
    ]
  },
  {
    id: 'pro',
    name: 'Pro',
    price: 59,
    color: 'var(--purple)',
    popular: true,
    features: [
      'Everything in Starter',
      '15 protected master slots (vs 5)',
      'Priority enforcement: host escalations, manual site sweeps, follow-up notices',
      'X & social platform takedowns',
      'Bing deindexing (coming soon)',
      'Connect Dropbox / Google Drive: whole-catalog fingerprinting (watermarking when available) (coming soon)',
      'Buyer-level leak tracing for customs & direct sales (coming soon)',
      'Identity & dox threat monitoring (coming soon)',
      'Dark web surveillance (coming soon)',
      'Telegram leak monitoring (coming soon)',
      'Fake profile detection (coming soon)',
      'Priority support',
      '3-day free trial',
    ]
  },
  {
    id: 'clean_slate',
    name: 'Clean Slate',
    price: 49,
    color: 'var(--teal)',
    features: [
      'For former creators',
      'Upload old content',
      'Perpetual weekly crawl',
      'No username required',
      'Full anonymity',
      'Auto DMCA + deindex',
      'Monthly removal report',
      '3-day free trial',
    ]
  },
];

export default function Pricing() {
  const [loading, setLoading] = useState(null);
  const token = localStorage.getItem('tribal_token');
  const isLoggedIn = !!token;

  const subscribe = async (planId) => {
    if (!isLoggedIn) {
      window.location.href = '/login';
      return;
    }
    setLoading(planId);
    try {
      const { data } = await axios.post(
        API + '/api/billing/checkout',
        { plan: planId },
        { headers: { Authorization: 'Bearer ' + token } }
      );
      window.location.href = data.url;
    } catch (e) {
      alert('Checkout failed: ' + (e.response?.data?.error || e.message));
    }
    setLoading(null);
  };

  return (
    <div className="page">
      {isLoggedIn && <Sidebar />}
      <div className="main">
        <div style={{ maxWidth: 900, margin:'0 auto' }}>
          <div style={{ textAlign:'center', marginBottom: 40 }}>
            <div style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>
              Choose your plan
            </div>
            <div style={{ color:'var(--muted)', fontSize: 15 }}>
              Cancel anytime. No contracts.
            </div>
          </div>

          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(200px, 1fr))', gap: 16 }}>
            {plans.map(plan => (
              <div
                key={plan.id}
                className="card"
                style={{
                  border: plan.popular ? '2px solid var(--purple)' : '1px solid var(--border)',
                  position:'relative',
                }}
              >
                {plan.popular && (
                  <div style={{
                    position:'absolute', top:-12, left:'50%', transform:'translateX(-50%)',
                    background:'var(--purple)', color:'white', fontSize: 11,
                    fontWeight: 600, padding:'2px 12px', borderRadius: 10,
                    whiteSpace:'nowrap'
                  }}>
                    Most popular
                  </div>
                )}

                <div style={{ fontSize: 11, fontWeight: 600, color: plan.color, letterSpacing:'.06em', marginBottom: 8 }}>
                  {plan.name.toUpperCase()}
                </div>

                <div style={{ display:'flex', alignItems:'baseline', gap: 4, marginBottom: 4 }}>
                  <span style={{ fontSize: 36, fontWeight: 700 }}>${plan.price}</span>
                  <span style={{ color:'var(--muted)', fontSize: 13 }}>/month</span>
                </div>

                <div style={{ borderTop:'1px solid var(--border)', margin:'16px 0', paddingTop: 16 }}>
                  {plan.features.map((f, i) => (
                    <div key={i} style={{ display:'flex', gap: 8, marginBottom: 8, fontSize: 13 }}>
                      <span style={{ color:'var(--green)', flexShrink: 0 }}>✓</span>
                      {f}
                    </div>
                  ))}
                </div>

                <button
                  className="btn btn-primary"
                  style={{ width:'100%', background: plan.color }}
                  onClick={() => subscribe(plan.id)}
                  disabled={loading === plan.id}
                >
                  {loading === plan.id ? 'Loading...' : 'Get started'}
                </button>
              </div>
            ))}
          </div>

          <div style={{ textAlign:'center', marginTop: 32, fontSize: 13, color:'var(--muted)' }}>
            All plans include a 3-day free trial. Cancel anytime before the trial ends.
          </div>
        </div>
      </div>
    </div>
  );
}
